import _defineProperty from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _toConsumableArray from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { useEffect, useRef, useMemo, useImperativeHandle } from 'react';
import _extends from '@babel/runtime/helpers/esm/extends';
import { is, each, toArray, usePrev, useOnce, useForceUpdate, Globals } from '@react-spring/shared';
export { Globals, createInterpolator } from '@react-spring/shared';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import { useMemoOne, useCallbackOne } from 'use-memo-one';
import { now, createStringInterpolator, frameLoop, skipAnimation, colorNames, requestAnimationFrame } from '@react-spring/shared/globals';
import { AnimatedArray, AnimatedValue, Animated } from '@react-spring/animated';
export { interpolate, isAnimated, to } from '@react-spring/animated';
import { createStringInterpolator as createStringInterpolator$1 } from '@react-spring/shared/stringInterpolation';

/** API
 *  useChain(references, timeSteps, timeFrame)
 */

function useChain(refs, timeSteps, timeFrame) {
  if (timeFrame === void 0) {
    timeFrame = 1000;
  }
  useEffect(function () {
    if (timeSteps) {
      var prevDelay = 0;
      refs.forEach(function (ref, i) {
        if (!ref.current) return;
        var controllers = ref.current.controllers;
        if (controllers.length) {
          var delay = timeFrame * timeSteps[i]; // Use the previous delay if none exists.

          if (isNaN(delay)) delay = prevDelay;else prevDelay = delay;
          controllers.forEach(function (ctrl) {
            ctrl.queue.forEach(function (props) {
              return props.delay += delay;
            });
            ctrl.start();
          });
        }
      });
    } else {
      var p = Promise.resolve();
      refs.forEach(function (ref) {
        var _ref = ref.current || {},
          controllers = _ref.controllers,
          start = _ref.start;
        if (controllers && controllers.length) {
          // Take the queue of each controller
          var updates = controllers.map(function (ctrl) {
            var q = ctrl.queue;
            ctrl.queue = [];
            return q;
          }); // Apply the queue when the previous ref stops animating

          p = p.then(function () {
            controllers.forEach(function (ctrl, i) {
              var _ctrl$queue;
              return (_ctrl$queue = ctrl.queue).push.apply(_ctrl$queue, _toConsumableArray(updates[i]));
            });
            return start();
          });
        } else {
          console.warn('useChain ref has no animations:', ref);
        }
      });
    }
  });
}
function fillArray(length, mapIndex) {
  var arr = [];
  for (var i = 0; i < length; i++) arr.push(mapIndex(i));
  return arr;
}
function withDefault(value, defaultValue) {
  return value == null ? defaultValue : value;
}
function callProp(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return is.fun(obj) ? obj.apply(void 0, args) : obj;
}
/**
 * Extract any properties whose keys are *not* reserved for customizing your
 * animations. All hooks use this function, which means `useTransition` props
 * are reserved for `useSpring` calls, etc.
 */

function getForwardProps(props) {
  var children = props.children,
    config = props.config,
    from = props.from,
    to = props.to,
    ref = props.ref,
    reset = props.reset,
    cancel = props.cancel,
    reverse = props.reverse,
    immediate = props.immediate,
    delay = props.delay,
    lazy = props.lazy,
    items = props.items,
    trail = props.trail,
    unique = props.unique,
    initial = props.initial,
    enter = props.enter,
    leave = props.leave,
    update = props.update,
    onAnimate = props.onAnimate,
    onStart = props.onStart,
    onRest = props.onRest,
    onFrame = props.onFrame,
    onDestroyed = props.onDestroyed,
    timestamp = props.timestamp,
    attach = props.attach,
    forward = _objectWithoutPropertiesLoose(props, ["children", "config", "from", "to", "ref", "reset", "cancel", "reverse", "immediate", "delay", "lazy", "items", "trail", "unique", "initial", "enter", "leave", "update", "onAnimate", "onStart", "onRest", "onFrame", "onDestroyed", "timestamp", "attach"]);
  return forward;
}
function interpolateTo(props) {
  var to = getForwardProps(props);
  var out = {
    to: to
  };
  each(props, function (val, key) {
    return key in to || (out[key] = val);
  });
  return out;
}
/**
 * This tries to put deleted items back into the given `out` list in correct
 * order. Deleted items must have a `left` and `right` property with key of
 * their sibling which is used to find the correct placement.
 */

function reconcileDeleted(deleted, current) {
  // Copy as we will be mutating the arrays
  deleted = _toConsumableArray(deleted);
  current = _toConsumableArray(current); // Used to detect deadlock (when a pass finds 0 siblings)

  var failedTries = 0; // Track where the current pass start/ends

  var passIndex = 0;
  var nextPassIndex = deleted.length; // Insert all deleted items into `current`

  for (var i = 0; i < deleted.length; i++) {
    if (i === nextPassIndex) {
      // Sanity test: Push to end if somehow no siblings were found
      if (passIndex + failedTries === nextPassIndex) {
        for (var j = i; j < deleted.length; j++) {
          var _deleted$j = deleted[j],
            _left = _deleted$j.left,
            _right = _deleted$j.right,
            _deletedItem = _objectWithoutPropertiesLoose(_deleted$j, ["left", "right"]);
          current.push(_deletedItem);
        }
        break;
      } // Update local state at the end of each pass

      passIndex = nextPassIndex;
      nextPassIndex = deleted.length;
      failedTries = 0;
    } // The index of the deleted item in `current`

    var index = -1; // Look for the left or right sibling in `current`

    var _deleted$i = deleted[i],
      left = _deleted$i.left,
      right = _deleted$i.right,
      deletedItem = _objectWithoutPropertiesLoose(_deleted$i, ["left", "right"]);
    for (var _j = current.length; --_j >= 0;) {
      var key = current[_j].originalKey;
      if (key === right) {
        index = _j;
        break;
      }
      if (key === left) {
        index = _j + 1;
        break;
      }
    } // Items with no index are revisited in the next pass

    if (index < 0) {
      failedTries++;
      deleted.push(deleted[i]);
    } else {
      current.splice(index, 0, deletedItem);
    }
  }
  return current;
}
function freeze(obj) {
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
    return Object.freeze(obj);
  }
  return obj;
}
var linear = function linear(t) {
  return t;
};
var emptyObj = Object.freeze({});
var nextId = 1;
var Controller = /*#__PURE__*/function () {
  function Controller(props) {
    _classCallCheck(this, Controller);
    this.id = nextId++;
    this.idle = true;
    this.runCount = 0;
    this.destroyed = false;
    this.props = {};
    this.queue = [];
    this.timestamps = {};
    this.values = {};
    this.merged = {};
    this.animated = {};
    this.animations = {};
    this.configs = [];
    this.children = [];
    this.onEndQueue = [];
    this.cancelledAt = 0;
    if (props) this.update(props).start();
  }
  /**
   * Push props into the update queue. The props are used after `start` is
   * called and any delay is over. The props are intelligently diffed to ensure
   * that later calls to this method properly override any delayed props.
   * The `propsArg` argument is always copied before mutations are made.
   */
  _createClass(Controller, [{
    key: "update",
    value: function update(propsArg) {
      if (!propsArg || this.destroyed) return this;
      var props = interpolateTo(propsArg); // For async animations, the `from` prop must be defined for
      // the Animated nodes to exist before animations have started.

      this._ensureAnimated(props.from, true);
      this._ensureAnimated(props.to);
      props.timestamp = now(); // The `delay` prop of every update must be a number >= 0

      if (is.fun(props.delay) && is.obj(props.to)) {
        var from = props.from || emptyObj;
        for (var key in props.to) {
          this.queue.push(_extends({}, props, {
            to: _defineProperty({}, key, props.to[key]),
            from: key in from ? _defineProperty({}, key, from[key]) : void 0,
            delay: Math.max(0, Math.round(props.delay(key)))
          }));
        }
      } else {
        props.delay = is.num(props.delay) ? Math.max(0, Math.round(props.delay)) : 0; // Coerce falsy values to undefined for these props

        if (!props.to) props.to = void 0;
        if (!props.from) props.from = void 0;
        this.queue.push(props);
      }
      return this;
    }
    /**
     * Flush the update queue, and call `onEnd` when they have settled.
     *
     * The `onEnd` callback does **not** wait for unsettled updates from previous `start` calls.
     */
  }, {
    key: "start",
    value: function start(onEnd) {
      if (this.queue.length) this._flush(onEnd);else if (onEnd) onEnd();
      return this;
    }
    /** Stop one animation or all animations */
  }, {
    key: "stop",
    value: function stop() {
      var _this = this;
      for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
        keys[_key] = arguments[_key];
      }

      // Stop animations by key
      if (keys.length) {
        var _iterator = _createForOfIteratorHelper(keys),
          _step;
        try {
          var _loop = function _loop() {
            var key = _step.value;
            var index = _this.configs.findIndex(function (config) {
              return key === config.key;
            });
            _this._stopAnimation(key);
            _this.configs[index] = _this.animations[key];
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Stop all animations
      else if (this.runCount) {
        this.cancelledAt = now(); // Update the animation configs

        each(this.configs, function (config) {
          return _this._stopAnimation(config.key);
        });
        this.configs = Object.values(this.animations); // Exit the frameloop

        if (!this.idle) {
          this._stop();
        }
      }
      return this;
    }
    /** Revert the controller to its initial state */
  }, {
    key: "reset",
    value: function reset() {
      // Stop all current animations
      this.stop(); // Revert the internal state

      this.destroyed = false;
      this.props = {};
      this.queue = [];
      this.timestamps = {};
      this.values = {};
      this.merged = {};
      this.animated = {};
      this.animations = {};
      this.configs = [];
      return this;
    }
    /** Prevent all current and future animation */
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.destroyed) {
        this.stop();
        this.destroyed = true;
      }
    }
    /** @internal Called by the frameloop */
  }, {
    key: "onFrame",
    value: function onFrame(_ref) {
      var id = _ref[0],
        idle = _ref[1],
        changes = _ref[2];
      if (id !== this.id) return;
      if (changes && changes.length) {
        var _iterator2 = _createForOfIteratorHelper(changes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _ref2 = _step2.value;
            var key = _ref2[0];
            var value = _ref2[1];
            this.values[key] = value;
          } // The `onFrame` prop always exists when `changes` exists.
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        this.props.onFrame(_extends({}, this.values));
      }
      if (idle) {
        this._stop();
      }
    }
    /**
     * Set a prop for the next animations where the prop is undefined. The given
     * value is overridden by the next update where the prop is defined.
     *
     * Ongoing animations are not changed.
     */
  }, {
    key: "setProp",
    value: function setProp(key, value) {
      this.props[key] = value;
      this.timestamps[key] = now();
      return this;
    }
    /** @internal Get the `AnimatedValue` nodes for the given key */
  }, {
    key: "getPayload",
    value: function getPayload(key) {
      var anim = this.animations[key];
      return anim && anim.animatedValues;
    } // Create an Animated node if none exists.
  }, {
    key: "_ensureAnimated",
    value: function _ensureAnimated(values, shouldUpdate) {
      if (shouldUpdate === void 0) {
        shouldUpdate = false;
      }
      if (!is.obj(values)) return;
      for (var key in values) {
        var value = values[key];
        var animated = this.animated[key];
        if (animated && shouldUpdate && this.animations[key].isNew) {
          // Ensure the initial value is up-to-date.
          if (animated.setValue) {
            animated.setValue(computeGoalValue(value));
          } else {
            // Derived nodes need to be swapped out.
            animated = null;
          }
        }
        if (!animated) {
          animated = createAnimated(value);
          if (this.animated[key]) {
            // Swap out the old node with the new node.
            moveChildren(this.animated[key], animated);
          }
          this.animated[key] = animated;
          this._stopAnimation(key, true);
        }
      }
    } // Add this controller to the frameloop.
  }, {
    key: "_start",
    value: function _start(onEnd) {
      if (this.idle) {
        if (this.configs.some(function (config) {
          return !config.idle;
        })) {
          this.idle = false;
          frameLoop.start(this);
        } else if (onEnd) {
          return onEnd();
        }
      }
      if (onEnd) {
        this.onEndQueue.push(onEnd);
      }
    } // Attach our children to the given keys if possible.
  }, {
    key: "_attach",
    value: function _attach(keys, visited) {
      var _this2 = this;
      if (visited === void 0) {
        visited = {};
      }
      each(this.children, function (c) {
        if (visited[_this2.id]) return;
        visited[_this2.id] = true;
        var attached = keys.filter(function (key) {
          var payload = c.getPayload(key);
          if (payload) {
            each(payload, function (node) {
              return node.done && node.reset(true);
            });
            return true;
          }
        });
        if (attached.length) {
          c._attach(attached, visited);
          c._start();
        }
      });
    } // Remove this controller from the frameloop, and notify any listeners.
  }, {
    key: "_stop",
    value: function _stop() {
      this.idle = true;
      frameLoop.stop(this);
      var onRest = this.props.onRest;
      if (is.fun(onRest)) {
        onRest(this.merged);
      }
      var onEndQueue = this.onEndQueue;
      if (onEndQueue.length) {
        this.onEndQueue = [];
        each(onEndQueue, function (onEnd) {
          return onEnd();
        });
      }
    } // Execute the current queue of prop updates.
  }, {
    key: "_flush",
    value: function _flush(onEnd) {
      var _this3 = this;
      var queue = this.queue.reduce(reduceDelays, []);
      this.queue.length = 0; // Track the number of unsettled updates.

      var runsLeft = Object.keys(queue).length;
      this.runCount += runsLeft; // Any run can finish last.

      var onRunEnd = function onRunEnd() {
        _this3.runCount--;
        if (! --runsLeft && onEnd) {
          onEnd();
        }
      };
      each(queue, function (props, delay) {
        if (delay) {
          setTimeout(function () {
            // Cancelling methods touch the `cancelledAt` property
            if (props.timestamp < _this3.cancelledAt) return;
            _this3._run(props, onRunEnd);
          }, delay);
        } else {
          _this3._run(props, onRunEnd);
        }
      });
    } // Update the props and animations
  }, {
    key: "_run",
    value: function _run(props, onEnd) {
      if (is.arr(props.to) || is.fun(props.to)) {
        this._runAsync(props, onEnd);
      } else if (this._diff(props)) {
        this._animate(props)._start(onEnd);
      } else {
        onEnd();
      }
    } // Start an async chain or an async script.
  }, {
    key: "_runAsync",
    value: function _runAsync(_ref3, onEnd) {
      var _this4 = this;
      var to = _ref3.to,
        props = _objectWithoutPropertiesLoose(_ref3, ["to"]);

      // Merge other props immediately.
      if (this._diff(props)) {
        this._animate(props);
      } // Async scripts can be declaratively cancelled.

      if (props.cancel === true) {
        this.props.asyncTo = void 0;
        return onEnd();
      } // Never run more than one script at a time

      var timestamp = props.timestamp;
      if (!this._diff({
        asyncTo: to,
        timestamp: timestamp
      })) {
        return onEnd();
      }
      var isCancelled = function isCancelled() {
        return (
          // Cancelling methods touch the `cancelledAt` property
          timestamp < _this4.cancelledAt ||
          // Async scripts are also cancelled when a new chain/script begins
          is.fun(to) && to !== _this4.props.asyncTo
        );
      };
      var last;
      var next = function next(props) {
        if (isCancelled()) throw _this4;
        return (last = new Promise(function (done) {
          _this4.update(props).start(done);
        })).then(function () {
          if (isCancelled()) throw _this4;
        });
      };
      var queue = Promise.resolve();
      if (is.arr(to)) {
        each(to, function (props) {
          queue = queue.then(function () {
            return next(props);
          });
        });
      } else if (is.fun(to)) {
        queue = queue.then(function () {
          return to(next, _this4.stop.bind(_this4)) // Always wait for the last update.
          .then(function () {
            return last;
          });
        });
      }
      queue.catch(function (err) {
        return err !== _this4 && console.error(err);
      }).then(onEnd);
    } // Merge every fresh prop. Returns true if one or more props changed.
    // These props cannot trigger an update by themselves:
    //   [delay, config, immediate, reverse, attach]
  }, {
    key: "_diff",
    value: function _diff(_ref4) {
      var _this5 = this;
      var timestamp = _ref4.timestamp,
        delay = _ref4.delay,
        config = _ref4.config,
        immediate = _ref4.immediate,
        reverse = _ref4.reverse,
        attach = _ref4.attach,
        props = _objectWithoutPropertiesLoose(_ref4, ["timestamp", "delay", "config", "immediate", "reverse", "attach"]);
      var changed = false; // Generalized diffing algorithm

      var diffProp = function diffProp(keys, value, owner) {
        if (is.und(value)) return;
        var lastKey = keys[keys.length - 1];
        if (is.obj(value)) {
          if (!is.obj(owner[lastKey])) owner[lastKey] = {};
          for (var key in value) {
            diffProp(keys.concat(key), value[key], owner[lastKey]);
          }
        } else {
          var keyPath = keys.join('.');
          var oldTimestamp = _this5.timestamps[keyPath];
          if (is.und(oldTimestamp) || timestamp >= oldTimestamp) {
            _this5.timestamps[keyPath] = timestamp;
            var oldValue = owner[lastKey];
            if (!isEqual(value, oldValue)) {
              changed = true;
              owner[lastKey] = value;
            }
          }
        }
      };
      if (reverse) {
        var to = props.to;
        props.to = props.from;
        props.from = is.obj(to) ? to : void 0;
      } // The "attach" prop is called on every diff. It overwrites the "parent" prop.

      props.parent = (attach ? attach(this) : props.parent) || null;
      var oldParent = this.props.parent || null;
      if (props.parent !== oldParent) {
        if (oldParent) oldParent.children.splice(oldParent.children.indexOf(this), 1);
        if (props.parent) props.parent.children.push(this);
      }
      for (var key in props) {
        diffProp([key], props[key], this.props);
      } // These props only affect one update

      if ('reset' in props) this.props.reset = false;
      if ('cancel' in props) this.props.cancel = void 0;
      return changed;
    } // Return true if the given prop was changed by this update
  }, {
    key: "_isModified",
    value: function _isModified(props, prop) {
      return this.timestamps[prop] === props.timestamp;
    } // Update the animation configs. The given props override any default props.
  }, {
    key: "_animate",
    value: function _animate(props) {
      var _this6 = this;
      var _this$props = this.props,
        _this$props$from = _this$props.from,
        from = _this$props$from === void 0 ? emptyObj : _this$props$from,
        _this$props$to = _this$props.to,
        to = _this$props$to === void 0 ? emptyObj : _this$props$to,
        parent = _this$props.parent,
        onAnimate = _this$props.onAnimate,
        onStart = _this$props.onStart;
      if (is.fun(onAnimate)) {
        onAnimate(props, this);
      }
      var isPrevented = function isPrevented(_) {
        return false;
      };
      if (props.cancel && this._isModified(props, 'cancel')) {
        // Stop all animations when `cancel` is true
        if (props.cancel === true) {
          this.stop(); // Prevent pending updates from *before* this update only!
          // (This must come after the `stop` call above)

          this.cancelledAt = props.timestamp;
          return this;
        } // Prevent matching properties from animating when
        // `cancel` is a string or array of strings

        var keys = toArray(props.cancel);
        if (is.arr(keys) && keys.length) {
          isPrevented = function isPrevented(key) {
            return keys.indexOf(key) >= 0;
          };
          this.stop.apply(this, _toConsumableArray(keys));
        }
      } // Merge `from` values with `to` values

      this.merged = freeze(_extends({}, from, to)); // True if any animation was updated

      var changed = false; // The animations that are starting or restarting

      var started = []; // Attach when a new "parent" controller exists.

      var isAttaching = parent && this._isModified(props, 'parent'); // Reduces input { key: value } pairs into animation objects
      var _loop2 = function _loop2() {
          if (isPrevented(key)) return 0; // continue
          var state = _this6.animations[key];
          if (!state) {
            console.warn("Failed to animate key: \"".concat(key, "\"\n") + "Did you forget to define \"from.".concat(key, "\" for an async animation?"));
            return 0; // continue
          } // Reuse the Animated nodes whenever possible

          var animated = state.animated,
            animatedValues = state.animatedValues;
          var value = _this6.merged[key];
          var goalValue = computeGoalValue(value);
          var currValue = animated.getValue(); // Stop animations with a goal value equal to its current value.

          if (!props.reset && !isAttaching && isEqual(goalValue, currValue)) {
            // The animation might be stopped already.
            if (!state.idle) {
              changed = true;
              _this6._stopAnimation(key);
            }
            return 0; // continue
          } // Replace an animation when its goal value is changed (or it's been reset)

          if (props.reset || isAttaching || !isEqual(goalValue, state.isNew ? currValue : state.goalValue)) {
            var immediate = !!callProp((is.und(props.immediate) ? _this6.props : props).immediate, key);
            var isActive = animatedValues.some(function (node) {
              return !node.done;
            });
            var fromValue = !is.und(from[key]) ? computeGoalValue(from[key]) : goalValue; // Animatable strings use interpolation

            var isInterpolated = isAnimatableString(value);
            if (isInterpolated) {
              var output = [props.reset ? fromValue : currValue, goalValue];
              var input = animatedValues[0];
              if (input) {
                input.setValue(0, false);
                input.reset(isActive);
              } else {
                input = new AnimatedValue(0);
              }
              try {
                var prev = animated;
                animated = input.to({
                  output: output
                });
                moveChildren(prev, animated);
              } catch (err) {
                console.warn('Failed to interpolate string from "%s" to "%s"', output[0], output[1]);
                console.error(err);
                return 0; // continue
              }
              if (skipAnimation) {
                input.setValue(1);
                _this6._stopAnimation(key);
                return 0; // continue
              }
              if (immediate) {
                input.setValue(1, false);
              }
            } else {
              // Convert values into Animated nodes (reusing nodes whenever possible)
              if (is.arr(value)) {
                if (animated instanceof AnimatedArray) {
                  if (props.reset) animated.setValue(fromValue, false);
                  each(animatedValues, function (node) {
                    return node.reset(isActive);
                  });
                } else {
                  var _prev = animated;
                  animated = createAnimated(fromValue);
                  moveChildren(_prev, animated);
                }
              } else {
                if (animated instanceof AnimatedValue) {
                  if (props.reset) animated.setValue(fromValue, false);
                  animated.reset(isActive);
                } else {
                  var _prev2 = animated;
                  animated = new AnimatedValue(fromValue);
                  moveChildren(_prev2, animated);
                }
              }
              if (skipAnimation) {
                animated.setValue(goalValue);
                _this6._stopAnimation(key);
                return 0; // continue
              }
              if (immediate) {
                animated.setValue(goalValue, false);
              }
            } // Only change the "config" of updated animations.

            var _config = callProp(props.config, key) || callProp(_this6.props.config, key) || emptyObj;
            if (!(immediate || skipAnimation)) {
              started.push(key);
            }
            var fromValues = animatedValues.map(function (v) {
              return v.getValue();
            });
            var toValues = parent && parent.getPayload(key) || toArray(isInterpolated ? 1 : goalValue);
            changed = true;
            _this6.animations[key] = {
              key: key,
              idle: false,
              goalValue: goalValue,
              toValues: toValues,
              fromValues: fromValues,
              animated: animated,
              animatedValues: Array.from(animated.getPayload()),
              immediate: immediate,
              duration: _config.duration,
              easing: withDefault(_config.easing, linear),
              decay: _config.decay,
              mass: withDefault(_config.mass, 1),
              tension: withDefault(_config.tension, 170),
              friction: withDefault(_config.friction, 26),
              initialVelocity: withDefault(_config.velocity, 0),
              clamp: withDefault(_config.clamp, false),
              precision: withDefault(_config.precision, 0.005),
              config: _config
            };
          }
        },
        _ret;
      for (var key in this.merged) {
        _ret = _loop2();
        if (_ret === 0) continue;
      }
      if (changed) {
        if (started.length) {
          this._attach(started);
          if (is.fun(onStart)) each(started, function (key) {
            onStart(_this6.animations[key]);
          });
        } // Make animations available to the frameloop

        var _keys2 = Object.keys(this.animations);
        this.configs.length = _keys2.length;
        each(_keys2, function (key, i) {
          var config = _this6.animations[key];
          _this6.configs[i] = config;
          _this6.values[key] = config.animated.getValue();
          _this6.animated[key] = config.animated;
        });
      }
      return this;
    }
    /**
     * Stop an animation by its key.
     *
     * This mutates the `timestamps.to[key]`, `props.to[key]`, and `animations[key]` properties.
     * Notably, it does *not* mutate the `configs[key]` or `animated[key]` properties.
     */
  }, {
    key: "_stopAnimation",
    value: function _stopAnimation(key, isNew) {
      var animated = this.animated[key];
      if (!animated) {
        return console.warn("Cannot stop an animation for a key that isn't animated: \"".concat(key, "\""));
      } // Prevent any pending updates to this key

      this.timestamps['to.' + key] = now(); // Idle animations are skipped unless their Animated node changed

      var state = this.animations[key] || emptyObj;
      if (state.idle && animated === state.animated) return; // Use the previous `isNew` value if nothing was passed

      if (is.und(isNew)) {
        isNew = !!state.isNew;
      } // Tell the frameloop to skip animating these values

      var animatedValues = Array.from(animated.getPayload());
      each(animatedValues, function (node) {
        node.done = true;
      }); // The current value becomes the goal value,
      // which ensures the integrity of the diffing algorithm.

      var goalValue = animated.getValue();
      if (this.props.to) {
        this.props.to[key] = goalValue;
      } // Remove unused data from this key's animation config

      this.animations[key] = {
        key: key,
        idle: true,
        isNew: isNew,
        goalValue: goalValue,
        animated: animated,
        animatedValues: animatedValues
      };
    }
  }]);
  return Controller;
}();
/** Wrap any value with an `Animated` node */
function createAnimated(value) {
  return is.arr(value) ? new AnimatedArray(value.map(createAnimated)) : isAnimatableString(value) ?
  // Convert "red" into "rgba(255, 0, 0, 1)" etc
  new AnimatedValue(0).to({
    output: [value, value]
  }) :
  // The `AnimatedValue` class supports any type, but only numbers are
  // interpolated by the frameloop.
  new AnimatedValue(value);
}
/**
 * Replace an `Animated` node in the graph.
 * This is most useful for async updates, which don't cause a re-render.
 */

function moveChildren(prev, next) {
  each(Array.from(prev.getChildren()), function (child) {
    child.updatePayload(prev, next);
    prev.removeChild(child);
    next.addChild(child);
  });
} // Merge updates with the same delay.
// NOTE: Mutation of `props` may occur!

function reduceDelays(merged, props) {
  var prev = merged[props.delay];
  if (prev) {
    props.to = merge(prev.to, props.to);
    props.from = merge(prev.from, props.from);
    Object.assign(prev, props);
  } else {
    merged[props.delay] = props;
  }
  return merged;
}
function merge(dest, src) {
  return is.obj(dest) && is.obj(src) ? _extends({}, dest, src) : src || dest;
} // Not all strings can be animated (eg: {display: "none"})

function isAnimatableString(value) {
  if (!is.str(value)) return false;
  return value.startsWith('#') || /\d/.test(value) || !!(colorNames && colorNames[value]);
} // Compute the goal value, converting "red" to "rgba(255, 0, 0, 1)" in the process

function computeGoalValue(value) {
  return is.arr(value) ? value.map(computeGoalValue) : isAnimatableString(value) ? createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
} // Compare animatable values

function isEqual(a, b) {
  if (is.arr(a)) {
    if (!is.arr(b) || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  return a === b;
}

/** API
 * const props = useSprings(number, [{ ... }, { ... }, ...])
 * const [props, set] = useSprings(number, (i, controller) => ({ ... }))
 */

var useSprings = function useSprings(length, propsArg, deps) {
  var hasNewSprings = length !== usePrev(length);
  var isFn = is.fun(propsArg);
  var state = useRef({
    springs: [],
    ref: null
  }).current; // The `propsArg` coerced into an array

  var props = isFn ? [] : propsArg; // Recreate the controllers whenever `length` changes

  var springs = useMemoOne(function () {
    return fillArray(length, function (i) {
      var s = new Controller();
      var p = props[i] || (props[i] = callProp(propsArg, i, s));
      return s.update(p);
    });
  }, [length]);
  var _useMemo = useMemo(function () {
      return {
        /** Apply any pending updates */
        start: function start() {
          return Promise.all(state.springs.map(function (s) {
            return new Promise(function (done) {
              return s.start(done);
            });
          }));
        },
        /** Update the spring controllers */
        update: function update(props) {
          var isFn = is.fun(props);
          var isArr = is.arr(props);
          state.springs.forEach(function (spring, i) {
            spring.update(isFn ? callProp(props, i, spring) : isArr ? props[i] : props);
            if (!state.ref) spring.start();
          });
        },
        /** Stop one key or all keys from animating */
        stop: function stop() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return state.springs.forEach(function (s) {
            return s.stop.apply(s, args);
          });
        }
      };
    }, []),
    start = _useMemo.start,
    update = _useMemo.update,
    stop = _useMemo.stop;
  var ref = props[0] ? props[0].ref : isFn ? state.ref : null;
  useImperativeHandle(ref, function () {
    return {
      start: start,
      stop: stop,
      get controllers() {
        return state.springs;
      }
    };
  }); // Once mounted, update the local state and start any animations.

  useEffect(function () {
    if (!isFn || hasNewSprings) {
      props.forEach(function (p, i) {
        // Set default props for async updates
        springs[i].setProp('config', p.config);
        springs[i].setProp('immediate', p.immediate);
      });
    }
    if (hasNewSprings) {
      state.springs.forEach(function (s) {
        return s.destroy();
      });
      state.springs = springs;
      state.ref = ref;
      if (!ref) {
        springs.forEach(function (s) {
          return s.start();
        });
      }
    } else if (!isFn) {
      update(props);
    }
  }, deps); // Destroy the controllers on unmount

  useOnce(function () {
    return function () {
      state.springs.forEach(function (s) {
        return s.destroy();
      });
    };
  });
  var values = springs.map(function (s) {
    return _extends({}, s.animated);
  });
  return isFn ? [values, update, stop] : values;
};

/** API
 * const props = useSpring({ ... })
 * const [props, set] = useSpring(() => ({ ... }))
 */

var useSpring = function useSpring(props, deps) {
  var isFn = is.fun(props);
  var _useSprings = useSprings(1, isFn ? props : [props], deps),
    result = _useSprings[0],
    set = _useSprings[1],
    stop = _useSprings[2];
  return isFn ? [result[0], set, stop] : result;
};

/** API
 * const trails = useTrail(number, { ... })
 * const [trails, set] = useTrail(number, () => ({ ... }))
 */

var useTrail = function useTrail(length, propsArg) {
  var hasNewSprings = length !== usePrev(length);
  var isFn = is.fun(propsArg); // The `propsArg` coerced into an object

  var props = isFn ? null : propsArg; // Retain the controllers so we can update them.

  var springsRef = useRef([]);
  var springs = springsRef.current;
  if (hasNewSprings) springs.length = length; // The controllers are recreated whenever `length` changes.

  var _useSprings = useSprings(length, function (i, spring) {
      if (isFn && !props) {
        props = callProp(propsArg, spring) || {};
      }
      springs[i] = spring;
      return _extends({}, props, i > 0 && {
        attach: function attach() {
          return springs[i - 1];
        },
        onStart: withArgument(props.onStart, i),
        onFrame: withArgument(props.onFrame, i),
        onRest: withArgument(props.onRest, i)
      }, {
        config: callProp(props.config, i)
      });
    }),
    values = _useSprings[0],
    animate = _useSprings[1],
    stop = _useSprings[2];
  /** For imperative updates to the props of all springs in the trail */

  var update = useCallbackOne(function (propsArg) {
    return animate(function (i, spring) {
      var props = callProp(propsArg, i, spring) || {};
      var parent = springsRef.current[props.reverse ? i + 1 : i - 1];
      return _extends({}, props, {
        attach: function attach() {
          return parent;
        },
        config: callProp(props.config, i)
      });
    });
  }, []); // Update the animations on re-render when `propsArg` is an object
  // and the controllers were *not* created in the current render.

  useEffect(function () {
    if (!isFn && !hasNewSprings) {
      update(propsArg);
    }
  }); // Return the update/stop functions when the `propsArg` is a function.

  return isFn ? [values, update, stop] : values;
};
function withArgument(fn, arg) {
  return is.fun(fn) ? function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return fn.apply(void 0, args.concat([arg]));
  } : fn;
}

/** API
 * const transitions = useTransition(items, itemKeys, { ... })
 * const [transitions, update] = useTransition(items, itemKeys, () => ({ ... }))
 */

var guid = 0;
var INITIAL = 'initial';
var ENTER = 'enter';
var UPDATE = 'update';
var LEAVE = 'leave';
var makeKeys = function makeKeys(items, keys) {
  return (typeof keys === 'function' ? items.map(keys) : toArray(keys)).map(String);
};
var makeConfig = function makeConfig(props) {
  var items = props.items,
    keys = props.keys,
    rest = _objectWithoutPropertiesLoose(props, ["items", "keys"]);
  items = toArray(is.und(items) ? null : items);
  return _extends({
    items: items,
    keys: makeKeys(items, keys)
  }, rest);
};
function useTransition(input, keyTransform, props) {
  props = makeConfig(_extends({}, props, {
    items: input,
    keys: keyTransform || function (i) {
      return i;
    }
  }));
  var _props = props,
    _props$lazy = _props.lazy,
    lazy = _props$lazy === void 0 ? false : _props$lazy,
    _props$unique = _props.unique,
    from = _props.from,
    enter = _props.enter,
    leave = _props.leave,
    update = _props.update,
    onDestroyed = _props.onDestroyed,
    keys = _props.keys,
    items = _props.items,
    onFrame = _props.onFrame,
    _onRest = _props.onRest,
    onStart = _props.onStart,
    ref = _props.ref,
    extra = _objectWithoutPropertiesLoose(_props, ["lazy", "unique", "from", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "ref"]);
  var forceUpdate = useForceUpdate();
  var mounted = useRef(false);
  var state = useRef({
    mounted: false,
    first: true,
    deleted: [],
    current: {},
    transitions: [],
    prevProps: {},
    paused: !!ref,
    instances: !mounted.current && new Map(),
    forceUpdate: forceUpdate
  });
  useImperativeHandle(ref, function () {
    return {
      start: function start() {
        return Promise.all(Array.from(state.current.instances).map(function (_ref) {
          var c = _ref[1];
          return new Promise(function (r) {
            return c.start(r);
          });
        }));
      },
      stop: function stop(finished) {
        return Array.from(state.current.instances).forEach(function (_ref2) {
          var c = _ref2[1];
          return c.stop(finished);
        });
      },
      get controllers() {
        return Array.from(state.current.instances).map(function (_ref3) {
          var c = _ref3[1];
          return c;
        });
      }
    };
  }); // Update state

  state.current = diffItems(state.current, props);
  if (state.current.changed) {
    // Update state
    state.current.transitions.forEach(function (transition) {
      var phase = transition.phase,
        key = transition.key,
        item = transition.item,
        props = transition.props;
      if (!state.current.instances.has(key)) state.current.instances.set(key, new Controller()); // Avoid calling `onStart` more than once per transition.

      var started = false; // update the map object

      var ctrl = state.current.instances.get(key);
      var itemProps = _extends({}, extra, props, {
        onRest: function onRest(values) {
          if (state.current.mounted) {
            if (transition.destroyed) {
              // If no ref is given delete destroyed items immediately
              if (!ref && !lazy) cleanUp(state, key);
              if (onDestroyed) onDestroyed(item);
            } // A transition comes to rest once all its springs conclude

            var curInstances = Array.from(state.current.instances);
            var active = curInstances.some(function (_ref4) {
              var c = _ref4[1];
              return !c.idle;
            });
            if (!active && (ref || lazy) && state.current.deleted.length > 0) {
              cleanUp(state);
            }
            if (is.fun(_onRest)) {
              _onRest(item, phase, values);
            }
          }
        },
        onFrame: is.fun(onFrame) && function (values) {
          return onFrame(item, phase, values);
        },
        onStart: is.fun(onStart) && function (animation) {
          return started || (started = (onStart(item, phase, animation), true));
        } // Update controller
      });
      ctrl.update(itemProps);
      if (!state.current.paused) ctrl.start();
    });
  }
  useOnce(function () {
    state.current.mounted = mounted.current = true;
    return function () {
      state.current.mounted = mounted.current = false;
      Array.from(state.current.instances).map(function (_ref5) {
        var c = _ref5[1];
        return c.destroy();
      });
      state.current.instances.clear();
    };
  });
  return state.current.transitions.map(function (_ref6) {
    var item = _ref6.item,
      phase = _ref6.phase,
      key = _ref6.key;
    return {
      item: item,
      key: key,
      phase: phase,
      props: _extends({}, state.current.instances.get(key).animated)
    };
  });
}
function cleanUp(_ref7, filterKey) {
  var state = _ref7.current;
  var deleted = state.deleted;
  var _iterator3 = _createForOfIteratorHelper(deleted),
    _step3;
  try {
    var _loop3 = function _loop3() {
      var _ref8 = _step3.value;
      var key = _ref8.key;
      var filter = function filter(t) {
        return t.key !== key;
      };
      if (is.und(filterKey) || filterKey === key) {
        state.instances.delete(key);
        state.transitions = state.transitions.filter(filter);
        state.deleted = state.deleted.filter(filter);
      }
    };
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop3();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  state.forceUpdate();
}
function diffItems(_ref9, props) {
  var first = _ref9.first,
    current = _ref9.current,
    deleted = _ref9.deleted,
    prevProps = _ref9.prevProps,
    state = _objectWithoutPropertiesLoose(_ref9, ["first", "current", "deleted", "prevProps"]);
  var items = props.items,
    keys = props.keys,
    initial = props.initial,
    from = props.from,
    enter = props.enter,
    leave = props.leave,
    update = props.update,
    _props$trail = props.trail,
    trail = _props$trail === void 0 ? 0 : _props$trail,
    unique = props.unique,
    config = props.config,
    _props$order = props.order,
    order = _props$order === void 0 ? [ENTER, LEAVE, UPDATE] : _props$order;
  var _makeConfig = makeConfig(prevProps),
    _keys = _makeConfig.keys,
    _items = _makeConfig.items;
  if (props.reset) {
    current = {};
    state.transitions = [];
  } // Compare next keys with current keys

  var currentKeys = Object.keys(current);
  var currentSet = new Set(currentKeys);
  var nextSet = new Set(keys);
  var addedKeys = keys.filter(function (key) {
    return !currentSet.has(key);
  });
  var updatedKeys = update ? keys.filter(function (key) {
    return currentSet.has(key);
  }) : [];
  var deletedKeys = state.transitions.filter(function (t) {
    return !t.destroyed && !nextSet.has(t.originalKey);
  }).map(function (t) {
    return t.originalKey;
  });
  var delay = -trail;
  var _loop4 = function _loop4() {
    var phase = order.shift();
    if (phase === ENTER) {
      if (first && !is.und(initial)) {
        phase = INITIAL;
        from = initial;
      }
      addedKeys.forEach(function (key) {
        // In unique mode, remove fading out transitions if their key comes in again
        if (unique && deleted.find(function (d) {
          return d.originalKey === key;
        })) {
          deleted = deleted.filter(function (t) {
            return t.originalKey !== key;
          });
        }
        var i = keys.indexOf(key);
        var item = items[i];
        var enterProps = callProp(enter, item, i);
        current[key] = {
          phase: phase,
          originalKey: key,
          key: unique ? String(key) : guid++,
          item: item,
          props: _extends({
            delay: delay += trail,
            config: callProp(config, item, phase),
            from: callProp(from, item, i),
            to: enterProps
          }, is.obj(enterProps) && interpolateTo(enterProps))
        };
      });
    } else if (phase === LEAVE) {
      deletedKeys.forEach(function (key) {
        var i = _keys.indexOf(key);
        var item = _items[i];
        var leaveProps = callProp(leave, item, i);
        deleted.push(_extends({}, current[key], {
          phase: phase,
          destroyed: true,
          left: _keys[i - 1],
          right: _keys[i + 1],
          props: _extends({
            delay: delay += trail,
            config: callProp(config, item, phase),
            to: leaveProps
          }, is.obj(leaveProps) && interpolateTo(leaveProps))
        }));
        delete current[key];
      });
    } else if (phase === UPDATE) {
      updatedKeys.forEach(function (key) {
        var i = keys.indexOf(key);
        var item = items[i];
        var updateProps = callProp(update, item, i);
        current[key] = _extends({}, current[key], {
          phase: phase,
          props: _extends({
            delay: delay += trail,
            config: callProp(config, item, phase),
            to: updateProps
          }, is.obj(updateProps) && interpolateTo(updateProps))
        });
      });
    }
  };
  while (order.length) {
    _loop4();
  }
  var out = keys.map(function (key) {
    return current[key];
  });
  out = reconcileDeleted(deleted, out);
  return _extends({}, state, {
    first: first && !addedKeys.length,
    changed: !!(addedKeys.length || deletedKeys.length || updatedKeys.length),
    transitions: out,
    current: current,
    deleted: deleted,
    prevProps: props
  });
}
function Spring(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, ["children"]);
  return children(useSpring(props));
}
function Trail(_ref2) {
  var items = _ref2.items,
    children = _ref2.children,
    props = _objectWithoutPropertiesLoose(_ref2, ["items", "children"]);
  var trails = useTrail(items.length, props);
  return items.map(function (item, index) {
    var result = children(item, index);
    return is.fun(result) ? result(trails[index]) : result;
  });
}
function Transition(_ref3) {
  var items = _ref3.items,
    _ref3$keys = _ref3.keys,
    keys = _ref3$keys === void 0 ? null : _ref3$keys,
    children = _ref3.children,
    props = _objectWithoutPropertiesLoose(_ref3, ["items", "keys", "children"]);
  var transitions = useTransition(items, keys, props);
  return transitions.map(function (_ref4, index) {
    var item = _ref4.item,
      key = _ref4.key,
      props = _ref4.props,
      phase = _ref4.phase;
    var result = children(item, phase, index);
    var element = is.fun(result) ? result(props) : result;
    return element && element.type ? React.createElement(element.type, _extends({}, element.props, {
      key: key,
      ref: element.ref
    })) : element;
  });
}
var FrameLoop = /*#__PURE__*/function () {
  function FrameLoop(_temp) {
    var _this7 = this;
    _classCallCheck(this, FrameLoop);
    var _ref = _temp === void 0 ? {} : _temp,
      update = _ref.update,
      onFrame = _ref.onFrame,
      requestFrame = _ref.requestFrame;

    /**
     * On each frame, these controllers are searched for values to animate.
     */
    this.controllers = new Map();
    /**
     * True when no controllers are animating.
     */

    this.idle = true;
    this.requestFrame =
    // The global `requestAnimationFrame` must be dereferenced to avoid "Illegal invocation" errors
    requestFrame || function (fn) {
      return (0, requestAnimationFrame)(fn);
    };
    this.onFrame = onFrame && onFrame.bind(this) || function (updates) {
      updates.forEach(function (update) {
        var ctrl = _this7.controllers.get(update[0]);
        if (ctrl) ctrl.onFrame(update);
      });
    };
    this.update = update && update.bind(this) || function () {
      if (_this7.idle) {
        return false;
      } // Update the animations.

      var updates = [];
      for (var _i = 0, _Array$from = Array.from(_this7.controllers.keys()); _i < _Array$from.length; _i++) {
        var id = _Array$from[_i];
        var idle = true;
        var ctrl = _this7.controllers.get(id);
        var changes = ctrl.props.onFrame ? [] : null;
        var _iterator4 = _createForOfIteratorHelper(ctrl.configs),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _config2 = _step4.value;
            if (_config2.idle) continue;
            if (_this7.advance(_config2, changes)) {
              idle = false;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        updates.push([id, idle, changes]);
      } // Notify the controllers!

      _this7.onFrame(updates); // Are we done yet?

      if (!_this7.controllers.size) {
        return !(_this7.idle = true);
      } // Keep going.

      _this7.requestFrame(_this7.update);
      return true;
    };
  }
  _createClass(FrameLoop, [{
    key: "start",
    value: function start(ctrl) {
      this.controllers.set(ctrl.id, ctrl);
      if (this.idle) {
        this.idle = false;
        this.requestFrame(this.update);
      }
    }
  }, {
    key: "stop",
    value: function stop(ctrl) {
      this.controllers.delete(ctrl.id);
    }
    /** Advance an animation forward one frame. */
  }, {
    key: "advance",
    value: function advance(config, changes) {
      var time = now();
      var active = false;
      var changed = false;
      for (var i = 0; i < config.animatedValues.length; i++) {
        var animated = config.animatedValues[i];
        if (animated.done) continue;
        changed = true;
        var to = config.toValues[i];
        var target = to instanceof Animated ? to : null;
        if (target) to = target.getValue(); // Jump to end value for immediate animations

        if (config.immediate) {
          animated.setValue(to);
          animated.done = true;
          continue;
        }
        var from = config.fromValues[i];
        var startTime = animated.startTime; // Break animation when string values are involved

        if (typeof from === 'string' || typeof to === 'string') {
          animated.setValue(to);
          animated.done = true;
          continue;
        }
        var finished = false;
        var position = animated.lastPosition;
        var velocity = Array.isArray(config.initialVelocity) ? config.initialVelocity[i] : config.initialVelocity; // Duration easing

        if (config.duration !== void 0) {
          position = from + config.easing((time - startTime) / config.duration) * (to - from);
          finished = time >= startTime + config.duration;
        } // Decay easing
        else if (config.decay) {
          var decay = config.decay === true ? 0.998 : config.decay;
          position = from + velocity / (1 - decay) * (1 - Math.exp(-(1 - decay) * (time - startTime)));
          finished = Math.abs(animated.lastPosition - position) < 0.1;
          if (finished) to = position;
        } // Spring easing
        else {
          var lastTime = animated.lastTime !== void 0 ? animated.lastTime : time;
          if (animated.lastVelocity !== void 0) {
            velocity = animated.lastVelocity;
          } // If we lost a lot of frames just jump to the end.

          if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/

          var numSteps = Math.floor(time - lastTime);
          for (var n = 0; n < numSteps; ++n) {
            var force = -config.tension * (position - to);
            var damping = -config.friction * velocity;
            var acceleration = (force + damping) / config.mass;
            velocity = velocity + acceleration * 1 / 1000;
            position = position + velocity * 1 / 1000;
          }
          animated.lastTime = time;
          animated.lastVelocity = velocity; // Conditions for stopping the spring animation

          var isOvershooting = config.clamp && config.tension !== 0 ? from < to ? position > to : position < to : false;
          var isVelocity = Math.abs(velocity) <= config.precision;
          var isDisplacement = config.tension !== 0 ? Math.abs(to - position) <= config.precision : true;
          finished = isOvershooting || isVelocity && isDisplacement;
        } // Trails aren't done until their parents conclude

        if (finished && !(target && !target.done)) {
          // Ensure that we end up with a round value
          if (animated.value !== to) position = to;
          animated.done = true;
        } else {
          active = true;
        }
        animated.setValue(position);
        animated.lastPosition = position;
      }
      if (changes && changed) {
        changes.push([config.key, config.animated.getValue()]);
      }
      return active;
    }
  }]);
  return FrameLoop;
}();
Globals.assign({
  frameLoop: new FrameLoop(),
  createStringInterpolator: createStringInterpolator$1,
  applyAnimatedValues: function applyAnimatedValues() {
    return false;
  }
});
/** Advance all animations forward one frame */

var update = function update() {
  return Globals.frameLoop.update();
};

// The `mass` prop defaults to 1
var config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};
export { Controller, FrameLoop, Spring, Trail, Transition, config, update, useChain, useSpring, useSprings, useTrail, useTransition };